import mod from '@/js/modernisierung';
import konstanten from '@/js/konstanten';
import { kasseClient } from '@/js/helpers/backend-clients';
import { defaultState } from './state';
import UploadFile from '@/js/uploadFile';
import { displayAxiosError } from '@/js/helpers/utils';

export default {
  SET_ONCE_OBJEKTART(state, objektart) {
    if (state.allgemeineAngaben.objektart === undefined) {
      state.allgemeineAngaben.objektart = objektart;
    }
  },
  SET_ERMITTLUNGSSTICHTAG(state, ermittlungsstichtag) {
    state.allgemeineAngaben.ermittlungsstichtag = ermittlungsstichtag;
  },
  SET_BAUJAHR(state, baujahr) {
    state.allgemeineAngaben.baujahr = baujahr;
  },
  SET_WOHNUNGSNUMMER(state, wohnungsnummer) {
    state.allgemeineAngaben.wohnungsnummer = wohnungsnummer;
  },
  SET_ANZAHL_WOHNEINHEITEN(state, anzahlWohneinheiten) {
    const number = parseInt(anzahlWohneinheiten);
    state.allgemeineAngaben.anzahlWohneinheiten = isNaN(number) ? undefined : number;
  },
  SET_ANZAHL_NUTZEINHEITEN(state, anzahlNutzeinheiten) {
    const number = parseInt(anzahlNutzeinheiten);
    state.allgemeineAngaben.anzahlNutzeinheiten = isNaN(number) ? undefined : number;
  },
  SET_WOHNFLAECHE(state, wohnflaeche) {
    const number = parseFloat(wohnflaeche);
    state.allgemeineAngaben.wohnflaeche = isNaN(number) ? undefined : number;
  },
  SET_NUTZFLAECHE(state, nutzflaeche) {
    const number = parseFloat(nutzflaeche);
    state.allgemeineAngaben.nutzflaeche = isNaN(number) ? undefined : number;
  },
  SET_KERNSANIERUNG(state, kernsanierung) {
    state.allgemeineAngaben.kernsanierung = kernsanierung;
    if (!kernsanierung) {
      state.allgemeineAngaben.jahrDerKernsanierung = undefined;
    }
  },
  SET_JAHR_DER_KERNSANIERUNG(state, jahrDerKernsanierung) {
    state.allgemeineAngaben.jahrDerKernsanierung = jahrDerKernsanierung;
  },

  SET_AUSSENWAENDE_MODERNISIERUNG(state, modernisierung) {
    state.aussenwaende.modernisierung = modernisierung;
    if (modernisierung === mod.KEINE.value) {
      state.aussenwaende.jahrDerModernisierung = undefined;
    }
  },
  SET_AUSSENWAENDE_JAHR_DER_MODERNISIERUNG(state, jahrDerModernisierung) {
    state.aussenwaende.jahrDerModernisierung = jahrDerModernisierung;
  },
  SET_AUSSENWAENDE_ERLAEUTERUNG(state, erlaeuterung) {
    state.aussenwaende.erlaeuterung = erlaeuterung;
  },
  SET_AUSSENWAENDE_AUSSENANSICHT_VORNE(state, aussenansichtVorne) {
    state.aussenwaende.fotos.aussenansichtVorne = UploadFile.instanceOf(aussenansichtVorne);
    kasseClient
      .uploadOrDelete(aussenansichtVorne, 'ndgmfh', '_foto_vorne_aussen', 0)
      .then(() => state.aussenwaende.fotos.aussenansichtVorne?.done())
      .catch(error => {
        displayAxiosError(error);
        state.aussenwaende.fotos.aussenansichtVorne = undefined;
      });
  },
  SET_AUSSENWAENDE_AUSSENANSICHT_HINTEN(state, aussenansichtHinten) {
    state.aussenwaende.fotos.aussenansichtHinten = UploadFile.instanceOf(aussenansichtHinten);
    kasseClient
      .uploadOrDelete(aussenansichtHinten, 'ndgmfh', '_foto_hinten_aussen', 0)
      .then(() => state.aussenwaende.fotos.aussenansichtHinten?.done())
      .catch(error => {
        displayAxiosError(error);
        state.aussenwaende.fotos.aussenansichtHinten = undefined;
      });
  },
  SET_AUSSENWAENDE_OFFENSICHTLICHE_SCHAEDEN(state, offensichtlicheSchaeden) {
    state.aussenwaende.fotos.offensichtlicheSchaeden =
      UploadFile.instanceOf(offensichtlicheSchaeden);
    kasseClient
      .uploadOrDelete(offensichtlicheSchaeden, 'ndgmfh', '_foto_schaeden_aussen', 0)
      .then(() => state.aussenwaende.fotos.offensichtlicheSchaeden?.done())
      .catch(error => {
        displayAxiosError(error);
        state.aussenwaende.fotos.offensichtlicheSchaeden = undefined;
      });
  },
  PUSH_AUSSENWAENDE_ZUSATZFOTO(state, zusatzfoto) {
    if (state.aussenwaende.fotos.zusatzfoto.length < konstanten.MAX_NUMBER_ZUSATZFOTOS) {
      state.aussenwaende.fotos.zusatzfoto.push(UploadFile.instanceOf(zusatzfoto));
      kasseClient
        .uploadFile(zusatzfoto, 'ndgmfh', '_foto_zusatz_aussen')
        .then(() =>
          state.aussenwaende.fotos.zusatzfoto.filter(foto => foto.file === zusatzfoto)[0]?.done(),
        )
        .catch(error => {
          displayAxiosError(error);
          const index = state.aussenwaende.fotos.zusatzfoto
            .map(foto => foto.file)
            .indexOf(zusatzfoto);
          state.aussenwaende.fotos.zusatzfoto.splice(index, 1);
        });
    }
  },
  REMOVE_AUSSENWAENDE_ZUSATZFOTO(state, zusatzfoto) {
    const index = state.aussenwaende.fotos.zusatzfoto.map(foto => foto.file).indexOf(zusatzfoto);
    if (index > -1) {
      kasseClient
        .deleteFile('ndgmfh', '_foto_zusatz_aussen', index)
        .then(() => state.aussenwaende.fotos.zusatzfoto.splice(index, 1));
    }
  },

  SET_DACH_MODERNISIERUNG(state, modernisierung) {
    state.dach.modernisierung = modernisierung;
    if (modernisierung === mod.KEINE.value) {
      state.dach.jahrDerModernisierung = undefined;
    }
  },
  SET_DACH_JAHR_DER_MODERNISIERUNG(state, jahrDerModernisierung) {
    state.dach.jahrDerModernisierung = jahrDerModernisierung;
  },
  SET_DACH_ERLAEUTERUNG(state, erlaeuterung) {
    state.dach.erlaeuterung = erlaeuterung;
  },
  SET_DACH_DACHEINDECKUNG_AUSSEN(state, dacheindeckungAussen) {
    state.dach.fotos.dacheindeckungAussen = UploadFile.instanceOf(dacheindeckungAussen);
    kasseClient
      .uploadOrDelete(dacheindeckungAussen, 'ndgmfh', '_foto_aussen_dach', 0)
      .then(() => state.dach.fotos.dacheindeckungAussen?.done())
      .catch(error => {
        displayAxiosError(error);
        state.dach.fotos.dacheindeckungAussen = undefined;
      });
  },
  SET_DACH_DACHGESCHOSS_INNEN(state, dachgeschossInnen) {
    state.dach.fotos.dachgeschossInnen = UploadFile.instanceOf(dachgeschossInnen);
    kasseClient
      .uploadOrDelete(dachgeschossInnen, 'ndgmfh', '_foto_innen_dach', 0)
      .then(() => state.dach.fotos.dachgeschossInnen?.done())
      .catch(error => {
        displayAxiosError(error);
        state.dach.fotos.dachgeschossInnen = undefined;
      });
  },
  SET_DACH_OFFENSICHTLICHE_SCHAEDEN(state, offensichtlicheSchaeden) {
    state.dach.fotos.offensichtlicheSchaeden = UploadFile.instanceOf(offensichtlicheSchaeden);
    kasseClient
      .uploadOrDelete(offensichtlicheSchaeden, 'ndgmfh', '_foto_schaeden_dach', 0)
      .then(() => state.dach.fotos.offensichtlicheSchaeden?.done())
      .catch(error => {
        displayAxiosError(error);
        state.dach.fotos.offensichtlicheSchaeden = undefined;
      });
  },
  PUSH_DACH_ZUSATZFOTO(state, zusatzfoto) {
    if (state.dach.fotos.zusatzfoto.length < konstanten.MAX_NUMBER_ZUSATZFOTOS) {
      state.dach.fotos.zusatzfoto.push(UploadFile.instanceOf(zusatzfoto));
      kasseClient
        .uploadFile(zusatzfoto, 'ndgmfh', '_foto_zusatz_dach')
        .then(() => state.dach.fotos.zusatzfoto.filter(foto => foto.file === zusatzfoto)[0]?.done())
        .catch(error => {
          displayAxiosError(error);
          const index = state.dach.fotos.zusatzfoto.map(foto => foto.file).indexOf(zusatzfoto);
          state.dach.fotos.zusatzfoto.splice(index, 1);
        });
    }
  },
  REMOVE_DACH_ZUSATZFOTO(state, zusatzfoto) {
    const index = state.dach.fotos.zusatzfoto.map(foto => foto.file).indexOf(zusatzfoto);
    if (index > -1) {
      kasseClient
        .deleteFile('ndgmfh', '_foto_zusatz_dach', index)
        .then(() => state.dach.fotos.zusatzfoto.splice(index, 1));
    }
  },

  SET_FENSTER_MODERNISIERUNG(state, modernisierung) {
    state.fenster.modernisierung = modernisierung;
    if (modernisierung === mod.KEINE.value) {
      state.fenster.jahrDerModernisierung = undefined;
    }
  },
  SET_FENSTER_JAHR_DER_MODERNISIERUNG(state, jahrDerModernisierung) {
    state.fenster.jahrDerModernisierung = jahrDerModernisierung;
  },
  SET_FENSTER_ERLAEUTERUNG(state, erlaeuterung) {
    state.fenster.erlaeuterung = erlaeuterung;
  },
  SET_FENSTER_HAUSEINGANSTUER(state, hauseingangstuer) {
    state.fenster.fotos.hauseingangstuer = UploadFile.instanceOf(hauseingangstuer);
    kasseClient
      .uploadOrDelete(hauseingangstuer, 'ndgmfh', '_foto_tuer_roll', 0)
      .then(() => state.fenster.fotos.hauseingangstuer?.done())
      .catch(error => {
        displayAxiosError(error);
        state.fenster.fotos.hauseingangstuer = undefined;
      });
  },
  SET_FENSTER_FENSTER(state, fenster) {
    state.fenster.fotos.fenster = UploadFile.instanceOf(fenster);
    kasseClient
      .uploadOrDelete(fenster, 'ndgmfh', '_foto_fenster_roll', 0)
      .then(() => state.fenster.fotos.fenster?.done())
      .catch(error => {
        displayAxiosError(error);
        state.fenster.fotos.fenster = undefined;
      });
  },
  SET_FENSTER_OFFENSICHTLICHE_SCHAEDEN(state, offensichtlicheSchaeden) {
    state.fenster.fotos.offensichtlicheSchaeden = UploadFile.instanceOf(offensichtlicheSchaeden);
    kasseClient
      .uploadOrDelete(offensichtlicheSchaeden, 'ndgmfh', '_foto_schaeden_roll', 0)
      .then(() => state.fenster.fotos.offensichtlicheSchaeden?.done())
      .catch(error => {
        displayAxiosError(error);
        state.fenster.fotos.offensichtlicheSchaeden = undefined;
      });
  },
  PUSH_FENSTER_ZUSATZFOTO(state, zusatzfoto) {
    if (state.fenster.fotos.zusatzfoto.length < konstanten.MAX_NUMBER_ZUSATZFOTOS) {
      state.fenster.fotos.zusatzfoto.push(UploadFile.instanceOf(zusatzfoto));
      kasseClient
        .uploadFile(zusatzfoto, 'ndgmfh', '_foto_zusatz_roll')
        .then(() =>
          state.fenster.fotos.zusatzfoto.filter(foto => foto.file === zusatzfoto)[0]?.done(),
        )
        .catch(error => {
          displayAxiosError(error);
          const index = state.fenster.fotos.zusatzfoto.map(foto => foto.file).indexOf(zusatzfoto);
          state.fenster.fotos.zusatzfoto.splice(index, 1);
        });
    }
  },
  REMOVE_FENSTER_ZUSATZFOTO(state, zusatzfoto) {
    const index = state.fenster.fotos.zusatzfoto.map(foto => foto.file).indexOf(zusatzfoto);
    if (index > -1) {
      kasseClient
        .deleteFile('ndgmfh', '_foto_zusatz_roll', index)
        .then(() => state.fenster.fotos.zusatzfoto.splice(index, 1));
    }
  },

  SET_FUSSBOEDEN_MODERNISIERUNG(state, modernisierung) {
    state.fussboeden.modernisierung = modernisierung;
    if (modernisierung === mod.KEINE.value) {
      state.fussboeden.jahrDerModernisierung = undefined;
    }
  },
  SET_FUSSBOEDEN_JAHR_DER_MODERNISIERUNG(state, jahrDerModernisierung) {
    state.fussboeden.jahrDerModernisierung = jahrDerModernisierung;
  },
  SET_FUSSBOEDEN_ERLAEUTERUNG(state, erlaeuterung) {
    state.fussboeden.erlaeuterung = erlaeuterung;
  },
  SET_FUSSBOEDEN_FUSSBODEN1(state, fussboden1) {
    state.fussboeden.fotos.fussboden1 = UploadFile.instanceOf(fussboden1);
    kasseClient
      .uploadOrDelete(fussboden1, 'ndgmfh', '_foto_boden1_boden', 0)
      .then(() => state.fussboeden.fotos.fussboden1?.done())
      .catch(error => {
        displayAxiosError(error);
        state.fussboeden.fotos.fussboden1 = undefined;
      });
  },
  SET_FUSSBOEDEN_FUSSBODEN2(state, fussboden2) {
    state.fussboeden.fotos.fussboden2 = UploadFile.instanceOf(fussboden2);
    kasseClient
      .uploadOrDelete(fussboden2, 'ndgmfh', '_foto_boden2_boden', 0)
      .then(() => state.fussboeden.fotos.fussboden2?.done())
      .catch(error => {
        displayAxiosError(error);
        state.fussboeden.fotos.fussboden2 = undefined;
      });
  },
  SET_FUSSBOEDEN_FUSSBODEN3(state, fussboden3) {
    state.fussboeden.fotos.fussboden3 = UploadFile.instanceOf(fussboden3);
    kasseClient
      .uploadOrDelete(fussboden3, 'ndgmfh', '_foto_boden3_boden', 0)
      .then(() => state.fussboeden.fotos.fussboden3?.done())
      .catch(error => {
        displayAxiosError(error);
        state.fussboeden.fotos.fussboden3 = undefined;
      });
  },
  SET_FUSSBOEDEN_OFFENSICHTLICHE_SCHAEDEN(state, offensichtlicheSchaeden) {
    state.fussboeden.fotos.offensichtlicheSchaeden = UploadFile.instanceOf(offensichtlicheSchaeden);
    kasseClient
      .uploadOrDelete(offensichtlicheSchaeden, 'ndgmfh', '_foto_schaeden_boden', 0)
      .then(() => state.fussboeden.fotos.offensichtlicheSchaeden?.done())
      .catch(error => {
        displayAxiosError(error);
        state.fussboeden.fotos.offensichtlicheSchaeden = undefined;
      });
  },
  PUSH_FUSSBOEDEN_ZUSATZFOTO(state, zusatzfoto) {
    if (state.fussboeden.fotos.zusatzfoto.length < konstanten.MAX_NUMBER_ZUSATZFOTOS) {
      state.fussboeden.fotos.zusatzfoto.push(UploadFile.instanceOf(zusatzfoto));
      kasseClient
        .uploadFile(zusatzfoto, 'ndgmfh', '_foto_zusatz_boden')
        .then(() =>
          state.fussboeden.fotos.zusatzfoto.filter(foto => foto.file === zusatzfoto)[0]?.done(),
        )
        .catch(error => {
          displayAxiosError(error);
          const index = state.fussboeden.fotos.zusatzfoto
            .map(foto => foto.file)
            .indexOf(zusatzfoto);
          state.fussboeden.fotos.zusatzfoto.splice(index, 1);
        });
    }
  },
  REMOVE_FUSSBOEDEN_ZUSATZFOTO(state, zusatzfoto) {
    const index = state.fussboeden.fotos.zusatzfoto.map(foto => foto.file).indexOf(zusatzfoto);
    if (index > -1) {
      kasseClient
        .deleteFile('ndgmfh', '_foto_zusatz_boden', index)
        .then(() => state.fussboeden.fotos.zusatzfoto.splice(index, 1));
    }
  },

  SET_INNENWAENDE_MODERNISIERUNG(state, modernisierung) {
    state.innenwaende.modernisierung = modernisierung;
    if (modernisierung === mod.KEINE.value) {
      state.innenwaende.jahrDerModernisierung = undefined;
    }
  },
  SET_INNENWAENDE_JAHR_DER_MODERNISIERUNG(state, jahrDerModernisierung) {
    state.innenwaende.jahrDerModernisierung = jahrDerModernisierung;
  },
  SET_INNENWAENDE_ERLAEUTERUNG(state, erlaeuterung) {
    state.innenwaende.erlaeuterung = erlaeuterung;
  },
  SET_INNENWAENDE_INNENTUER1(state, innentuer1) {
    state.innenwaende.fotos.innentuer1 = UploadFile.instanceOf(innentuer1);
    kasseClient
      .uploadOrDelete(innentuer1, 'ndgmfh', '_foto_tuer1_innen', 0)
      .then(() => state.innenwaende.fotos.innentuer1?.done())
      .catch(error => {
        displayAxiosError(error);
        state.innenwaende.fotos.innentuer1 = undefined;
      });
  },
  SET_INNENWAENDE_INNENTUER2(state, innentuer2) {
    state.innenwaende.fotos.innentuer2 = UploadFile.instanceOf(innentuer2);
    kasseClient
      .uploadOrDelete(innentuer2, 'ndgmfh', '_foto_tuer2_innen', 0)
      .then(() => state.innenwaende.fotos.innentuer2?.done())
      .catch(error => {
        displayAxiosError(error);
        state.innenwaende.fotos.innentuer2 = undefined;
      });
  },
  SET_INNENWAENDE_INNENWAND1(state, innenwand1) {
    state.innenwaende.fotos.innenwand1 = UploadFile.instanceOf(innenwand1);
    kasseClient
      .uploadOrDelete(innenwand1, 'ndgmfh', '_foto_wand1_innen', 0)
      .then(() => state.innenwaende.fotos.innenwand1?.done())
      .catch(error => {
        displayAxiosError(error);
        state.innenwaende.fotos.innenwand1 = undefined;
      });
  },
  SET_INNENWAENDE_INNENWAND2(state, innenwand2) {
    state.innenwaende.fotos.innenwand2 = UploadFile.instanceOf(innenwand2);
    kasseClient
      .uploadOrDelete(innenwand2, 'ndgmfh', '_foto_wand2_innen', 0)
      .then(() => state.innenwaende.fotos.innenwand2?.done())
      .catch(error => {
        displayAxiosError(error);
        state.innenwaende.fotos.innenwand2 = undefined;
      });
  },
  SET_INNENWAENDE_INNENWAND3(state, innenwand3) {
    state.innenwaende.fotos.innenwand3 = UploadFile.instanceOf(innenwand3);
    kasseClient
      .uploadOrDelete(innenwand3, 'ndgmfh', '_foto_wand3_innen', 0)
      .then(() => state.innenwaende.fotos.innenwand3?.done())
      .catch(error => {
        displayAxiosError(error);
        state.innenwaende.fotos.innenwand3 = undefined;
      });
  },
  SET_INNENWAENDE_OFFENSICHTLICHE_SCHAEDEN(state, offensichtlicheSchaeden) {
    state.innenwaende.fotos.offensichtlicheSchaeden =
      UploadFile.instanceOf(offensichtlicheSchaeden);
    kasseClient
      .uploadOrDelete(offensichtlicheSchaeden, 'ndgmfh', '_foto_schaeden_innen', 0)
      .then(() => state.innenwaende.fotos.offensichtlicheSchaeden?.done())
      .catch(error => {
        displayAxiosError(error);
        state.innenwaende.fotos.offensichtlicheSchaeden = undefined;
      });
  },
  PUSH_INNENWAENDE_ZUSATZFOTO(state, zusatzfoto) {
    if (state.innenwaende.fotos.zusatzfoto.length < konstanten.MAX_NUMBER_ZUSATZFOTOS) {
      state.innenwaende.fotos.zusatzfoto.push(UploadFile.instanceOf(zusatzfoto));
      kasseClient
        .uploadFile(zusatzfoto, 'ndgmfh', '_foto_zusatz_innen')
        .then(() =>
          state.innenwaende.fotos.zusatzfoto.filter(foto => foto.file === zusatzfoto)[0]?.done(),
        )
        .catch(error => {
          displayAxiosError(error);
          const index = state.innenwaende.fotos.zusatzfoto
            .map(foto => foto.file)
            .indexOf(zusatzfoto);
          state.innenwaende.fotos.zusatzfoto.splice(index, 1);
        });
    }
  },
  REMOVE_INNENWAENDE_ZUSATZFOTO(state, zusatzfoto) {
    const index = state.innenwaende.fotos.zusatzfoto.map(foto => foto.file).indexOf(zusatzfoto);
    if (index > -1) {
      kasseClient
        .deleteFile('ndgmfh', '_foto_zusatz_innen', index)
        .then(() => state.innenwaende.fotos.zusatzfoto.splice(index, 1));
    }
  },

  SET_DECKEN_MODERNISIERUNG(state, modernisierung) {
    state.decken.modernisierung = modernisierung;
    if (modernisierung === mod.KEINE.value) {
      state.decken.jahrDerModernisierung = undefined;
    }
  },
  SET_DECKEN_JAHR_DER_MODERNISIERUNG(state, jahrDerModernisierung) {
    state.decken.jahrDerModernisierung = jahrDerModernisierung;
  },
  SET_DECKEN_ERLAEUTERUNG(state, erlaeuterung) {
    state.decken.erlaeuterung = erlaeuterung;
  },
  SET_DECKEN_TREPPE1(state, treppe1) {
    state.decken.fotos.treppe1 = UploadFile.instanceOf(treppe1);
    kasseClient
      .uploadOrDelete(treppe1, 'ndgmfh', '_foto_treppe1_decke', 0)
      .then(() => state.decken.fotos.treppe1?.done())
      .catch(error => {
        displayAxiosError(error);
        state.decken.fotos.treppe1 = undefined;
      });
  },
  SET_DECKEN_TREPPE2(state, treppe2) {
    state.decken.fotos.treppe2 = UploadFile.instanceOf(treppe2);
    kasseClient
      .uploadOrDelete(treppe2, 'ndgmfh', '_foto_treppe2_decke', 0)
      .then(() => state.decken.fotos.treppe2?.done())
      .catch(error => {
        displayAxiosError(error);
        state.decken.fotos.treppe2 = undefined;
      });
  },
  SET_DECKEN_DECKENKONSTRUKTION1(state, deckenkonstruktion1) {
    state.decken.fotos.deckenkonstruktion1 = UploadFile.instanceOf(deckenkonstruktion1);
    kasseClient
      .uploadOrDelete(deckenkonstruktion1, 'ndgmfh', '_foto_decke1_decke', 0)
      .then(() => state.decken.fotos.deckenkonstruktion1?.done())
      .catch(error => {
        displayAxiosError(error);
        state.decken.fotos.deckenkonstruktion1 = undefined;
      });
  },
  SET_DECKEN_DECKENKONSTRUKTION2(state, deckenkonstruktion2) {
    state.decken.fotos.deckenkonstruktion2 = UploadFile.instanceOf(deckenkonstruktion2);
    kasseClient
      .uploadOrDelete(deckenkonstruktion2, 'ndgmfh', '_foto_decke2_decke', 0)
      .then(() => state.decken.fotos.deckenkonstruktion2?.done())
      .catch(error => {
        displayAxiosError(error);
        state.decken.fotos.deckenkonstruktion2 = undefined;
      });
  },
  SET_DECKEN_OFFENSICHTLICHE_SCHAEDEN(state, offensichtlicheSchaeden) {
    state.decken.fotos.offensichtlicheSchaeden = UploadFile.instanceOf(offensichtlicheSchaeden);
    kasseClient
      .uploadOrDelete(offensichtlicheSchaeden, 'ndgmfh', '_foto_schaeden_decke', 0)
      .then(() => state.decken.fotos.offensichtlicheSchaeden?.done())
      .catch(error => {
        displayAxiosError(error);
        state.decken.fotos.offensichtlicheSchaeden = undefined;
      });
  },
  PUSH_DECKEN_ZUSATZFOTO(state, zusatzfoto) {
    if (state.decken.fotos.zusatzfoto.length < konstanten.MAX_NUMBER_ZUSATZFOTOS) {
      state.decken.fotos.zusatzfoto.push(UploadFile.instanceOf(zusatzfoto));
      kasseClient
        .uploadFile(zusatzfoto, 'ndgmfh', '_foto_zusatz_decke')
        .then(() =>
          state.decken.fotos.zusatzfoto.filter(foto => foto.file === zusatzfoto)[0]?.done(),
        )
        .catch(error => {
          displayAxiosError(error);
          const index = state.decken.fotos.zusatzfoto.map(foto => foto.file).indexOf(zusatzfoto);
          state.decken.fotos.zusatzfoto.splice(index, 1);
        });
    }
  },
  REMOVE_DECKEN_ZUSATZFOTO(state, zusatzfoto) {
    const index = state.decken.fotos.zusatzfoto.map(foto => foto.file).indexOf(zusatzfoto);
    if (index > -1) {
      kasseClient
        .deleteFile('ndgmfh', '_foto_zusatz_decke', index)
        .then(() => state.decken.fotos.zusatzfoto.splice(index, 1));
    }
  },

  SET_SANITAER_MODERNISIERUNG(state, modernisierung) {
    state.sanitaer.modernisierung = modernisierung;
    if (modernisierung === mod.KEINE.value) {
      state.sanitaer.jahrDerModernisierung = undefined;
    }
  },
  SET_SANITAER_JAHR_DER_MODERNISIERUNG(state, jahrDerModernisierung) {
    state.sanitaer.jahrDerModernisierung = jahrDerModernisierung;
  },
  SET_SANITAER_ERLAEUTERUNG(state, erlaeuterung) {
    state.sanitaer.erlaeuterung = erlaeuterung;
  },
  SET_SANITAER_BAD1(state, bad1) {
    state.sanitaer.fotos.bad1 = UploadFile.instanceOf(bad1);
    kasseClient
      .uploadOrDelete(bad1, 'ndgmfh', '_foto_bad1_bad', 0)
      .then(() => state.sanitaer.fotos.bad1?.done())
      .catch(error => {
        displayAxiosError(error);
        state.sanitaer.fotos.bad1 = undefined;
      });
  },
  SET_SANITAER_BAD2(state, bad2) {
    state.sanitaer.fotos.bad2 = UploadFile.instanceOf(bad2);
    kasseClient
      .uploadOrDelete(bad2, 'ndgmfh', '_foto_bad2_bad', 0)
      .then(() => state.sanitaer.fotos.bad2?.done())
      .catch(error => {
        displayAxiosError(error);
        state.sanitaer.fotos.bad2 = undefined;
      });
  },
  SET_SANITAER_OFFENSICHTLICHE_SCHAEDEN(state, offensichtlicheSchaeden) {
    state.sanitaer.fotos.offensichtlicheSchaeden = UploadFile.instanceOf(offensichtlicheSchaeden);
    kasseClient
      .uploadOrDelete(offensichtlicheSchaeden, 'ndgmfh', '_foto_schaeden_bad', 0)
      .then(() => state.sanitaer.fotos.offensichtlicheSchaeden?.done())
      .catch(error => {
        displayAxiosError(error);
        state.sanitaer.fotos.offensichtlicheSchaeden = undefined;
      });
  },
  PUSH_SANITAER_ZUSATZFOTO(state, zusatzfoto) {
    if (state.sanitaer.fotos.zusatzfoto.length < konstanten.MAX_NUMBER_ZUSATZFOTOS) {
      state.sanitaer.fotos.zusatzfoto.push(UploadFile.instanceOf(zusatzfoto));
      kasseClient
        .uploadFile(zusatzfoto, 'ndgmfh', '_foto_zusatz_bad')
        .then(() =>
          state.sanitaer.fotos.zusatzfoto.filter(foto => foto.file === zusatzfoto)[0]?.done(),
        )
        .catch(error => {
          displayAxiosError(error);
          const index = state.sanitaer.fotos.zusatzfoto.map(foto => foto.file).indexOf(zusatzfoto);
          state.sanitaer.fotos.zusatzfoto.splice(index, 1);
        });
    }
  },
  REMOVE_SANITAER_ZUSATZFOTO(state, zusatzfoto) {
    const index = state.sanitaer.fotos.zusatzfoto.map(foto => foto.file).indexOf(zusatzfoto);
    if (index > -1) {
      kasseClient
        .deleteFile('ndgmfh', '_foto_zusatz_bad', index)
        .then(() => state.sanitaer.fotos.zusatzfoto.splice(index, 1));
    }
  },

  SET_HEIZUNG_MODERNISIERUNG(state, modernisierung) {
    state.heizung.modernisierung = modernisierung;
    if (modernisierung === mod.KEINE.value) {
      state.heizung.jahrDerModernisierung = undefined;
    }
  },
  SET_HEIZUNG_JAHR_DER_MODERNISIERUNG(state, jahrDerModernisierung) {
    state.heizung.jahrDerModernisierung = jahrDerModernisierung;
  },
  SET_HEIZUNG_ERLAEUTERUNG(state, erlaeuterung) {
    state.heizung.erlaeuterung = erlaeuterung;
  },
  SET_HEIZUNG_HEIZUNGSANLAGE1(state, heizungsanlage1) {
    state.heizung.fotos.heizungsanlage1 = UploadFile.instanceOf(heizungsanlage1);
    kasseClient
      .uploadOrDelete(heizungsanlage1, 'ndgmfh', '_foto_heizung1_heizung', 0)
      .then(() => state.heizung.fotos.heizungsanlage1?.done())
      .catch(error => {
        displayAxiosError(error);
        state.heizung.fotos.heizungsanlage1 = undefined;
      });
  },
  SET_HEIZUNG_HEIZUNGSANLAGE2(state, heizungsanlage2) {
    state.heizung.fotos.heizungsanlage2 = UploadFile.instanceOf(heizungsanlage2);
    kasseClient
      .uploadOrDelete(heizungsanlage2, 'ndgmfh', '_foto_heizung2_heizung', 0)
      .then(() => state.heizung.fotos.heizungsanlage2?.done())
      .catch(error => {
        displayAxiosError(error);
        state.heizung.fotos.heizungsanlage2 = undefined;
      });
  },
  SET_HEIZUNG_OFFENSICHTLICHE_SCHAEDEN(state, offensichtlicheSchaeden) {
    state.heizung.fotos.offensichtlicheSchaeden = UploadFile.instanceOf(offensichtlicheSchaeden);
    kasseClient
      .uploadOrDelete(offensichtlicheSchaeden, 'ndgmfh', '_foto_schaeden_heizung', 0)
      .then(() => state.heizung.fotos.offensichtlicheSchaeden?.done())
      .catch(error => {
        displayAxiosError(error);
        state.heizung.fotos.offensichtlicheSchaeden = undefined;
      });
  },
  PUSH_HEIZUNG_ZUSATZFOTO(state, zusatzfoto) {
    if (state.heizung.fotos.zusatzfoto.length < konstanten.MAX_NUMBER_ZUSATZFOTOS) {
      state.heizung.fotos.zusatzfoto.push(UploadFile.instanceOf(zusatzfoto));
      kasseClient
        .uploadFile(zusatzfoto, 'ndgmfh', '_foto_zusatz_heizung')
        .then(() =>
          state.heizung.fotos.zusatzfoto.filter(foto => foto.file === zusatzfoto)[0]?.done(),
        )
        .catch(error => {
          displayAxiosError(error);
          const index = state.heizung.fotos.zusatzfoto.map(foto => foto.file).indexOf(zusatzfoto);
          state.heizung.fotos.zusatzfoto.splice(index, 1);
        });
    }
  },
  REMOVE_HEIZUNG_ZUSATZFOTO(state, zusatzfoto) {
    const index = state.heizung.fotos.zusatzfoto.map(foto => foto.file).indexOf(zusatzfoto);
    if (index > -1) {
      kasseClient
        .deleteFile('ndgmfh', '_foto_zusatz_heizung', index)
        .then(() => state.heizung.fotos.zusatzfoto.splice(index, 1));
    }
  },

  SET_TECHNISCHE_AUSSTATTUNG_MODERNISIERUNG(state, modernisierung) {
    state.technischeAusstattung.modernisierung = modernisierung;
    if (modernisierung === mod.KEINE.value) {
      state.technischeAusstattung.jahrDerModernisierung = undefined;
    }
  },
  SET_TECHNISCHE_AUSSTATTUNG_JAHR_DER_MODERNISIERUNG(state, jahrDerModernisierung) {
    state.technischeAusstattung.jahrDerModernisierung = jahrDerModernisierung;
  },
  SET_TECHNISCHE_AUSSTATTUNG_ERLAEUTERUNG(state, erlaeuterung) {
    state.technischeAusstattung.erlaeuterung = erlaeuterung;
  },
  SET_TECHNISCHE_AUSSTATTUNG_SICHERUNGSKASTEN(state, sicherungskasten) {
    state.technischeAusstattung.fotos.sicherungskasten = UploadFile.instanceOf(sicherungskasten);
    kasseClient
      .uploadOrDelete(sicherungskasten, 'ndgmfh', '_foto_sicherung_sonst', 0)
      .then(() => state.technischeAusstattung.fotos.sicherungskasten?.done())
      .catch(error => {
        displayAxiosError(error);
        state.technischeAusstattung.fotos.sicherungskasten = undefined;
      });
  },
  SET_TECHNISCHE_AUSSTATTUNG_STECKDOSEN(state, steckdosen) {
    state.technischeAusstattung.fotos.steckdosen = UploadFile.instanceOf(steckdosen);
    kasseClient
      .uploadOrDelete(steckdosen, 'ndgmfh', '_foto_stecklicht_sonst', 0)
      .then(() => state.technischeAusstattung.fotos.steckdosen?.done())
      .catch(error => {
        displayAxiosError(error);
        state.technischeAusstattung.fotos.steckdosen = undefined;
      });
  },
  SET_TECHNISCHE_AUSSTATTUNG_OFFENSICHTLICHE_SCHAEDEN(state, offensichtlicheSchaeden) {
    state.technischeAusstattung.fotos.offensichtlicheSchaeden =
      UploadFile.instanceOf(offensichtlicheSchaeden);
    kasseClient
      .uploadOrDelete(offensichtlicheSchaeden, 'ndgmfh', '_foto_schaeden_sonst', 0)
      .then(() => state.technischeAusstattung.fotos.offensichtlicheSchaeden?.done())
      .catch(error => {
        displayAxiosError(error);
        state.technischeAusstattung.fotos.offensichtlicheSchaeden = undefined;
      });
  },
  PUSH_TECHNISCHE_AUSSTATTUNG_ZUSATZFOTO(state, zusatzfoto) {
    if (state.technischeAusstattung.fotos.zusatzfoto.length < konstanten.MAX_NUMBER_ZUSATZFOTOS) {
      state.technischeAusstattung.fotos.zusatzfoto.push(UploadFile.instanceOf(zusatzfoto));
      kasseClient
        .uploadFile(zusatzfoto, 'ndgmfh', '_foto_zusatz_sonst')
        .then(() =>
          state.technischeAusstattung.fotos.zusatzfoto
            .filter(foto => foto.file === zusatzfoto)[0]
            ?.done(),
        )
        .catch(error => {
          displayAxiosError(error);
          const index = state.technischeAusstattung.fotos.zusatzfoto
            .map(foto => foto.file)
            .indexOf(zusatzfoto);
          state.technischeAusstattung.fotos.zusatzfoto.splice(index, 1);
        });
    }
  },
  REMOVE_TECHNISCHE_AUSSTATTUNG_ZUSATZFOTO(state, zusatzfoto) {
    const index = state.technischeAusstattung.fotos.zusatzfoto
      .map(foto => foto.file)
      .indexOf(zusatzfoto);
    if (index > -1) {
      kasseClient
        .deleteFile('ndgmfh', '_foto_zusatz_sonst', index)
        .then(() => state.technischeAusstattung.fotos.zusatzfoto.splice(index, 1));
    }
  },

  SET_OBJEKTUNTERLAGEN_GRUNDRISS(state, grundriss) {
    state.objektunterlagen.grundriss = UploadFile.instanceOf(grundriss);
    kasseClient
      .uploadOrDelete(grundriss, 'ndgmfh', '_grundriss_unterlagen', 0)
      .then(() => state.objektunterlagen.grundriss?.done())
      .catch(error => {
        displayAxiosError(error);
        state.objektunterlagen.grundriss = undefined;
      });
  },
  SET_OBJEKTUNTERLAGEN_ZUSATZDOKUMENT_GRUNDRISS(state, zusatzdokumentGrundriss) {
    state.objektunterlagen.zusatzdokumentGrundriss = UploadFile.instanceOf(zusatzdokumentGrundriss);
    kasseClient
      .uploadOrDelete(zusatzdokumentGrundriss, 'ndgmfh', '_grundriss_zusatz_unterlagen', 0)
      .then(() => state.objektunterlagen.zusatzdokumentGrundriss?.done())
      .catch(error => {
        displayAxiosError(error);
        state.objektunterlagen.zusatzdokumentGrundriss = undefined;
      });
  },
  SET_OBJEKTUNTERLAGEN_ENERGIEAUSWEIS(state, energieausweis) {
    state.objektunterlagen.energieausweis = UploadFile.instanceOf(energieausweis);
    kasseClient
      .uploadOrDelete(energieausweis, 'ndgmfh', '_grundriss_energieausweis', 0)
      .then(() => state.objektunterlagen.energieausweis?.done())
      .catch(error => {
        displayAxiosError(error);
        state.objektunterlagen.energieausweis = undefined;
      });
  },
  SET_OBJEKTUNTERLAGEN_ZUSATZDOKUMENT_ENERGIEAUSWEIS(state, zusatzdokumentEnergieausweis) {
    state.objektunterlagen.zusatzdokumentEnergieausweis = UploadFile.instanceOf(
      zusatzdokumentEnergieausweis,
    );
    kasseClient
      .uploadOrDelete(zusatzdokumentEnergieausweis, 'ndgmfh', '_grundriss_zusatz_energieausweis', 0)
      .then(() => state.objektunterlagen.zusatzdokumentEnergieausweis?.done())
      .catch(error => {
        displayAxiosError(error);
        state.objektunterlagen.zusatzdokumentEnergieausweis = undefined;
      });
  },

  SET_ANSPRECHPARTNER_NACHNAME(state, nachname) {
     window.sessionStorage.setItem('nname', nachname);
    state.ansprechpartner.nachname = nachname;
  },
  SET_ANSPRECHPARTNER_VORNAME(state, vorname) {
    window.sessionStorage.setItem('vname', vorname);
    state.ansprechpartner.vorname = vorname;
  },
  SET_ANSPRECHPARTNER_TELEFON(state, telefon) {
    state.ansprechpartner.telefon = telefon;
  },
  SET_ANSPRECHPARTNER_ERLAEUTERUNG(state, erlaeuterung) {
    state.ansprechpartner.erlaeuterung = erlaeuterung;
  },

  SET_DEFAULT_RECHNUNG_NAME1(state, name1) {
    state.defaultRechnung.name1 = name1;
  },
  SET_DEFAULT_RECHNUNG_NAME2(state, name2) {
    state.defaultRechnung.name2 = name2;
  },
  SET_DEFAULT_RECHNUNG_PLZ(state, plz) {
    state.defaultRechnung.plz = plz;
  },
  SET_DEFAULT_RECHNUNG_ORT(state, ort) {
    state.defaultRechnung.ort = ort;
  },
  SET_DEFAULT_RECHNUNG_STR(state, str) {
    state.defaultRechnung.str = str;
  },
  SET_DEFAULT_RECHNUNG_HNR(state, hnr) {
    state.defaultRechnung.hnr = hnr;
  },

  SET_ALTERNATIVE_RECHNUNG_NAME1(state, name1) {
    state.alternativeRechnung.name1 = name1;
  },
  SET_ALTERNATIVE_RECHNUNG_NAME2(state, name2) {
    state.alternativeRechnung.name2 = name2;
  },
  SET_ALTERNATIVE_RECHNUNG_PLZ(state, plz) {
    state.alternativeRechnung.plz = plz;
  },
  SET_ALTERNATIVE_RECHNUNG_ORT(state, ort) {
    state.alternativeRechnung.ort = ort;
  },
  SET_ALTERNATIVE_RECHNUNG_STR(state, str) {
    state.alternativeRechnung.str = str;
  },
  SET_ALTERNATIVE_RECHNUNG_HNR(state, hnr) {
    state.alternativeRechnung.hnr = hnr;
  },
  SET_USE_DEFAULT_RECHNUNG_DATA(state, useDefault) {
    state.alternativeRechnung.useDefault = useDefault;
  },

  RESET_STATE(state) {
    window.sessionStorage.removeItem('vname');
    window.sessionStorage.removeItem('nname');
    Object.assign(state, defaultState());
  },
};
